var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ParentEvent, RoundedPlane, ViewerModule } from '@g.frame/core';
import { Color, Group, Vector2, Vector3 } from 'three';
import PopUp from './PopUp';
import { ActionControllerEventName } from "@g.frame/common.action_controller";
import TaskProgressBar from "./TaskProgressBar";
import { OculusQuestModule } from "@g.frame/oculus.quest";
import { TextComponent } from "@g.frame/components.text";
import ModularPopUp from "./ModularPopUp";
import BackgroundElement from "./uiElements/BackgroundElement";
import HeaderTextElement from "./uiElements/HeaderTextElement";
import BodyTextElement from "./uiElements/BodyTextElement";
import TextButtonElement from "./uiElements/TextButtonElement";
import MuteButton from './components/MuteButton';
import { InstrumentsPackModule } from "../../instruments_pack/src/InstrumentsPackModule";
export default class UIManager extends ViewerModule {
    constructor() {
        super();
        this.musicActive = true;
        this.isVr = false;
    }
    init(modulesProcessor) {
        var _a;
        this.modulesProcessor = modulesProcessor;
        this.isVr = !!((_a = modulesProcessor.modulesInstances.get(OculusQuestModule)) === null || _a === void 0 ? void 0 : _a.length);
        if (this.isVr) {
            this.positionsConfig = {
                popup: new Vector3(-0.1, 0.175, 0.005),
                popupCentered: new Vector3(-0.1, 0.175, 0.005),
                menu: new Vector3(0.045, 0.225, 0),
                text: new Vector3(-0.1, 0.15, 0),
            };
            this.setVRTablet();
        }
        else {
            let onResize;
            window.addEventListener('resize', onResize = () => {
                this.ratio = window.innerWidth / window.innerHeight;
                this.positionsConfig = {
                    // task: new Vector3(-.15 + -0.12 * this.ratio, 0.38, 0),
                    popup: new Vector3(.255 - 0.39 * this.ratio, 0.395, 0.1),
                    popupCentered: new Vector3(0, .2, 0.1),
                    menu: new Vector3(0.21 * this.ratio, 0.36, 0.1),
                    // sideObject: new Vector3(-0.24 * this.ratio, 0.32, 0),
                    text: new Vector3(.30 - 0.45 * this.ratio, 0.43, 0),
                };
                // this.positionsConfig = {
                //     task: new Vector3(-0.24 * this.ratio, 0.38, 0),
                //     popup: new Vector3(-0.26 * this.ratio, 0.395, 0.1),
                //     popupCentered: new Vector3(0, .2, 0.1),
                //     menu: new Vector3(0.21 * this.ratio, 0.36, 0.1),
                //     sideObject: new Vector3(-0.24 * this.ratio, 0.32, 0),
                //     text: new Vector3(-0.30 * this.ratio, 0.43, 0),
                // };
                this.menuContainer && this.menuContainer.position.copy(this.positionsConfig.menu);
                this.text && this.text.uiObject.position.copy(this.positionsConfig.text);
                this.popUp && this.popUp.uiObject.position.copy(this.positionsConfig.popup);
            });
            onResize();
            this.uiObject.position.set(0, 0, -0.11);
            this.uiObject.scale.setScalar(.1);
            this.modulesProcessor.viewer.camera.add(this.uiObject);
        }
        this.addMenuButtons();
        this.actionController.on(ActionControllerEventName.click, this.exitButton, () => {
            window.close();
        });
        this.actionController.on(ActionControllerEventName.click, this.exitLobbyButton, () => {
            this.fire('exit_to_lobby', new ParentEvent('exit_to_lobby'));
        });
        this.actionController.on(ActionControllerEventName.click, this.playButton, () => {
            this.fire('play_button_click', new ParentEvent('play_button_click'));
        });
        // this.actionController.on(ActionControllerEventName.click, this.muteButton, () => {
        //     this.toggleMusic();
        // });
        this.mainTheme = this.loader.getResource('AUDIO_music');
    }
    setVRTablet() {
        this.instrumentsPackModule = this.modulesProcessor.modules.get(InstrumentsPackModule);
        const tablet = this.instrumentsPackModule.tablet;
        tablet.enable(true);
        tablet.uiObject.position.set(2.9, 0.8, -0.4);
        tablet.uiObject.rotation.set(0, Math.PI / 2, 0);
        tablet.addObject(this);
        this.uiObject.position.set(0.2, 0.053, -0.043);
        this.uiObject.rotation.set(-0.7, 0, 0);
        this.uiObject.scale.set(0.4, 0.4, 0.4);
    }
    progressUpdate(value) {
        this.progressBar.uiObject.visible = true;
        this.progressBar.uiObject.scale.setScalar(0.1);
        // this.currentUIStage.progressBar.value = value;
        this.progressBar.set({
            value: value,
            scale: 1
        });
    }
    setModules(loader, actionController, textComponentFactory) {
        this.loader = loader;
        this.actionController = actionController;
        this.textComponentFactory = textComponentFactory;
        this.progressBar = new TaskProgressBar();
        this.text = new ModularPopUp();
        this.muteButton = new MuteButton(this.loader, this.actionController);
        this.textBackground = new BackgroundElement();
        this.textHeader = new HeaderTextElement(this.loader, this.textComponentFactory);
        this.textBody = new BodyTextElement(this.loader, this.textComponentFactory);
        this.textButton = new TextButtonElement(this.loader, this.actionController, this.textComponentFactory);
        this.popUp = new PopUp(this.loader, this.actionController, this.textComponentFactory);
        this.popUp.uiObject.visible = false;
        this.popUp.on('first_button_click', () => {
            this.fire('first_button_click', new ParentEvent('first_button_click'));
        });
        this.popUp.on('second_button_click', () => {
            this.fire('second_button_click', new ParentEvent('second_button_click'));
        });
        this.text.on('button_click', () => {
            this.fire('task_button_click', new ParentEvent('task_button_click'));
        });
        this.addToContainer();
    }
    addToContainer() {
        this.addObject(this.progressBar);
        this.addObject(this.text);
        this.addObject(this.popUp);
    }
    update() {
    }
    setText(options) {
        setTimeout(() => {
            clearInterval(this.hideInterval);
            clearTimeout(this.hideTimeout);
            this.text.uiObject.position.copy(this.positionsConfig.text);
            this.text.set(options);
            this.text.uiObject.visible = true;
        }, 600);
    }
    getTextBackground(options) {
        this.textBackground.set(options);
        return this.textBackground;
    }
    getTextHeader(options) {
        this.textHeader.set(options);
        return this.textHeader;
    }
    getTextBody(options) {
        this.textBody.set(options);
        this.textBody.uiObject.position.set(0, 0, 0);
        return this.textBody;
    }
    getTextButton(options) {
        this.textButton.set(options);
        return this.textButton;
    }
    hideText() {
        return __awaiter(this, void 0, void 0, function* () {
            // this.progressBar.uiObject.visible = false;
            return new Promise((resolve => {
                if (!this.isVr) {
                    clearInterval(this.hideInterval);
                    this.hideInterval = setInterval(() => {
                        this.text.uiObject.position.y += 0.025;
                    }, 10);
                    this.hideTimeout = setTimeout(() => {
                        clearInterval(this.hideInterval);
                        resolve();
                        this.text.uiObject.visible = false;
                    }, 250);
                }
                else {
                    this.text.uiObject.visible = false;
                    resolve();
                }
            }));
        });
    }
    showWelcomePopUp(config) {
        const pop = {
            header: config.header,
            body: config.body,
            welcomeBodyRows: config.welcomeBodyRows || 3,
            type: 'welcome',
        };
        this.popUp.setPopUp(pop);
        this.popUp.update();
        this.popUp.uiObject.position.copy(this.positionsConfig.popupCentered);
        this.popUp.uiObject.visible = true;
    }
    showFailPopUp() {
        this.popUp.setPopUp({ type: 'fail' });
        this.popUp.uiObject.position.copy(this.positionsConfig.popup);
        this.popUp.uiObject.visible = true;
        this.popUp.once('first_button_click', () => {
            this.hidePopUpScreen();
        });
    }
    showSuccessPopUp() {
        this.popUp.setPopUp({ type: 'success' });
        this.popUp.uiObject.position.copy(this.positionsConfig.popup);
        this.popUp.uiObject.visible = true;
        this.popUp.once('first_button_click', () => {
            this.hidePopUpScreen();
        });
    }
    showFinalPopUp(config) {
        const pop = {
            body: config.body,
            secondButton: config.secondButton,
            header: config.header,
            type: 'final'
        };
        this.popUp.setPopUp(pop);
        this.popUp.uiObject.position.copy(this.positionsConfig.popup);
        this.popUp.uiObject.visible = true;
    }
    showPopUpScreen() {
        this.popUp.uiObject.visible = true;
    }
    hidePopUpScreen() {
        this.popUp.uiObject.visible = false;
    }
    hide() {
        // this.progressBar.uiObject.visible = false;
        this.text.uiObject.visible = false;
        this.popUp.uiObject.visible = false;
    }
    show() {
        // this.progressBar.uiObject.visible = true;
        this.text.uiObject.visible = true;
        this.popUp.uiObject.visible = true;
    }
    stopAudio() {
        // this.text.stopAudio();
        // this.popUp.stopAudio();
        if (this.successSound)
            this.successSound.pause();
    }
    playSuccessSound() {
        if (this.successSound)
            this.successSound.pause();
        this.stopAudio();
        this.hidePopUpScreen();
        this.successSound = this.getRandomSuccessSound();
        this.successSound.currentTime = 0;
        this.successSound.play();
    }
    getRandomSuccessSound() {
        const soundIndex = Math.floor(Math.random() * 4);
        return this.loader.getResource('VOICE_success_message_' + soundIndex);
    }
    toggleExitButton(mode) {
        this.exitButton.visible = mode;
        this.exitLobbyButton.visible = !mode;
        mode ? this.muteButton.uiObject.position.x = 0.15 : this.muteButton.uiObject.position.x = 0.05;
    }
    addMenuButtons() {
        this.menuContainer = new Group();
        this.menuContainer.scale.set(0.95, 0.95, 0.95);
        this.menuContainer.position.copy(this.positionsConfig.menu);
        this.muteButton.init();
        this.muteButton.uiObject.position.set(0.05, 0, 0);
        this.menuContainer.add(this.muteButton.uiObject);
        this.muteButton.on('music_toggle', (data) => {
            this.fire('music_toggle', new ParentEvent('music_toggle', { muted: data.data.muted }));
        });
        // exit button
        this.exitButton = this.createButton(new Vector2(0.1, 0.045));
        const exitText = this.textComponentFactory.getFactory(TextComponent)({
            size: new Vector2(0.09, 0.04),
            pxSize: new Vector2(512, 256),
            text: {
                value: 'Exit',
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '400',
                    size: '150px',
                    color: new Color('#FFFFFF').getStyle()
                },
                lineHeight: 160,
            },
            background: {
                color: new Color('#9DC458').getStyle(),
            }
        });
        exitText.uiObject.position.set(0, 0, 0.0001);
        this.exitButton.add(exitText.uiObject);
        this.exitButton.position.set(0.26, 0, 0);
        this.menuContainer.add(this.exitButton);
        // lobby
        // const size = new Vector2(0.45)
        this.exitLobbyButton = this.createButton(new Vector2(0.2, 0.045));
        const lobbyText = this.textComponentFactory.getFactory(TextComponent)({
            size: new Vector2(0.19, 0.043),
            pxSize: new Vector2(256 * (0.19 / 0.043), 256),
            text: {
                value: 'Back To Lobby',
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'ProximaNova',
                    weight: '400',
                    size: '150px',
                    color: new Color('#FFFFFF').getStyle()
                },
                lineHeight: 160,
            },
            background: {
                color: new Color('#9DC458').getStyle(),
            }
        });
        lobbyText.uiObject.position.set(0, 0, 0.0001);
        this.exitLobbyButton.add(lobbyText.uiObject);
        this.exitLobbyButton.position.set(0.2, 0, 0);
        this.menuContainer.add(this.exitLobbyButton);
        this.exitLobbyButton.visible = false;
        this.addObject(this.menuContainer);
    }
    createButton(size) {
        const button = new Group();
        // button.scale.set(0.5, 0.5, 0.5);
        const bPlaneOptions = {
            width: size.x + 0.007,
            height: size.y + 0.007,
            color: new Color('#5D772E').getHex(),
            r1: size.y / 3.5,
        };
        const fPlaneOptions = {
            width: size.x,
            height: size.y,
            color: new Color('#9DC458').getHex(),
            r1: size.y / 4,
        };
        const plane = RoundedPlane.getRoundedPlane(fPlaneOptions);
        const bplane = RoundedPlane.getRoundedPlane(bPlaneOptions);
        bplane.position.set(0, -0.001, -0.0001);
        button.add(plane);
        button.add(bplane);
        return button;
    }
}
